import React from 'react';
import { string, func } from 'prop-types';
import Button from '@coxautokc/fusion-ui-components/lib/Button';
import Col from '@coxautokc/fusion-ui-components/lib/Col';
import ButtonToolbar from 'react-bootstrap/lib/ButtonToolbar';
import Checkbox from 'react-bootstrap/lib/Checkbox';
import SelectInput from '@coxautokc/fusion-ui-components/lib/SelectInput';
import StateSelectInput from '@coxautokc/fusion-ui-components/lib/StateSelectInput';
import TextInput from '@coxautokc/fusion-ui-components/lib/TextInput';
import PostalCodeInput from '@coxautokc/fusion-ui-components/lib/PostalCodeInput';
import { Customer } from '../../../propTypes';
import './_customerInformationForm.scss';

const CustomerInformationForm = ({
  htmlId,
  customer,
  saveUpdate,
  cancelUpdate,
  updateCustomer
}) => (
  <div className="customerInformationForm" id={htmlId}>
    <h5>Customer</h5>
    <Checkbox
      name="isCompany"
      checked={customer.isCompany}
      onChange={updateCustomer}
    >
      {' '}
      Is this a Company?{' '}
    </Checkbox>
    {customer.isCompany && (
      <div className="customerInformationForm__row">
        <Col xs={6} md={3}>
          <TextInput
            label="Company Name"
            name="companyName"
            onChange={updateCustomer}
            maxLength={50}
            htmlId="customerCompanyName"
            value={customer.companyName}
          />
        </Col>
        <Col xs={6} md={3}>
          <SelectInput
            required
            htmlId="companyType"
            name="companyType"
            label="Company Type"
            onChange={updateCustomer}
            value={customer.companyType}
            options={[
              { value: 'Business', label: 'Business' },
              { value: 'Fleet', label: 'Fleet' },
              { value: 'Dealer', label: 'Dealer' }
            ]}
          />
        </Col>
      </div>
    )}
    <div className="customerInformationForm__row">
      <Col xs={6} md={3}>
        <TextInput
          label="First Name"
          name="firstName"
          onChange={updateCustomer}
          maxLength={50}
          htmlId="customerFirstName"
          value={customer.firstName}
        />
      </Col>
      <Col xs={6} md={3}>
        <TextInput
          label="Middle Name"
          name="middleName"
          onChange={updateCustomer}
          maxLength={50}
          htmlId="customerMiddleName"
          value={customer.middleName}
        />
      </Col>
      <Col xs={6} md={3}>
        <TextInput
          label="Last Name"
          name="lastName"
          onChange={updateCustomer}
          maxLength={50}
          htmlId="customerLastName"
          value={customer.lastName}
        />
      </Col>
    </div>
    <div className="customerInformationForm__row">
      <Col xs={6} md={6}>
        <TextInput
          label="Address"
          name="address.street"
          onChange={updateCustomer}
          maxLength={50}
          htmlId="customerStreet"
          value={customer.address.street}
        />
      </Col>
    </div>
    <div className="customerInformationForm__row">
      <Col xs={6} md={6}>
        <TextInput
          label="Address 2"
          name="address.street2"
          onChange={updateCustomer}
          maxLength={50}
          htmlId="customerStreet2"
          value={customer.address.street2}
        />
      </Col>
    </div>
    <div className="customerInformationForm__row">
      <Col xs={6} md={3}>
        <PostalCodeInput
          htmlId="customerPostalCodeInput"
          name="address.postal"
          label="Zip Code"
          required
          onChange={updateCustomer}
          value={customer.address.postal}
        />
      </Col>
      <Col xs={6} md={3}>
        <TextInput
          label="Address"
          name="address.city"
          onChange={updateCustomer}
          maxLength={50}
          htmlId="customerCity"
          value={customer.address.city}
        />
      </Col>
      <Col xs={6} md={3}>
        <StateSelectInput
          htmlId="customerStateSelectInput"
          name="address.state"
          onChange={updateCustomer}
          value={customer.address.state}
          country="All"
        />
      </Col>
    </div>
    <span className="customerInformationForm__buttonToolbar">
      <ButtonToolbar>
        <Button htmlId="MockAPIPageCancel" onClick={cancelUpdate}>
          Cancel
        </Button>
        <Button htmlId="MockAPIPageSave" bsStyle="primary" onClick={saveUpdate}>
          Save
        </Button>
      </ButtonToolbar>
    </span>
  </div>
);

CustomerInformationForm.propTypes = {
  cancelUpdate: func.isRequired,
  customer: Customer.isRequired,
  htmlId: string.isRequired,
  saveUpdate: func.isRequired,
  updateCustomer: func
};

export default CustomerInformationForm;



// WEBPACK FOOTER //
// ./src/components/pages/MockApiExamplePage/CustomerInformationForm.js